import { Box, TextButton } from '@shape-ds/components';
import { CaseStatus } from 'queries/cases/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './GoToStageBanner.scss';
import { useFormContext } from 'react-hook-form';
import { capitalize } from 'components/DownloadCSV/csvUtils';
interface NextStageProps {
  stageName: CaseStatus;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  shouldGo?: boolean;
}

const GoToStageBanner: React.FC<NextStageProps> = ({ stageName, onSubmit, shouldGo }) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();
  const stage = capitalize(t(`case:status.${stageName}`, { defaultValue: stageName }));

  return (
    <Box className="go-to-stage-banner">
      {shouldGo ? (
        <>
          <span className="go-to-stage-message">
            {t('case:goToStageBanner.message', { stage })}
          </span>

          <TextButton
            onClick={() => {
              setValue('status', stageName);
              onSubmit();
            }}
          >
            {t('case:goToStage.yes', { stage })}
          </TextButton>
        </>
      ) : (
        <span className="go-to-stage-message">
          {t('case:goToStageBanner.not_permitted', { stage })}
        </span>
      )}
    </Box>
  );
};

export default GoToStageBanner;
